import { createFilmFilter, getFilms } from '@vista/omnichannel-components-domain';
export const setupFilter = (filterConfig, siteId) => {
    var _a;
    if (!filterConfig)
        return;
    const { filterId, options } = filterConfig;
    const films = (_a = getFilms(siteId)) !== null && _a !== void 0 ? _a : [];
    createFilmFilter(filterId, films, siteId, options);
};
